module.exports = [{
"coords": [[1,2], [6,3]],
"mazeData": `
.___________.
| ._. | .___|
| | ._|___. |
| |_. | ._. |
| |_____|_. |
| ._. | ._| |
|___|___|___|
`}, {
"coords": [[2,4], [5,2]],
"mazeData": `
.___________.
|_. ._|   ._|
| ._| ._|_. |
| | ._| ._. |
| ._| ._| | |
| | | | ._| |
|_|___|_____|
`}, {
"coords": [[4,4], [6,4]],
"mazeData": `
.___________.
| ._. | | . |
|_| | |___| |
| . | | . | |
| | | | | | |
| |___| | | |
|_______|___|
`}, {
"coords": [[1,1], [1,4]],
"mazeData": `
.___________.
| . |_____. |
| | | .___. |
| |___| ._| |
| |_______. |
| ._____. | |
|_____|___|_|
`}, {
"coords": [[4,6], [5,3]],
"mazeData": `
.___________.
|_______. . |
| .___. ._|_|
| . |___| . |
| |___. |_| |
| | ._____| |
|_|_________|
`}, {
"coords": [[3,5], [5,1]],
"mazeData": `
.___________.
| | . |_. . |
| | | | ._| |
| ._|_| | ._|
|_. | . | | |
| ._|_| |_. |
|_______|___|
`}, {
"coords": [[2,1], [2,6]],
"mazeData": `
.___________.
| .___. | . |
| | ._|___| |
|___| ._| ._|
| . | .___| |
| |_|___. | |
|___________|
`}, {
"coords": [[3,4], [4,1]],
"mazeData": `
.___________.
| | ._. | . |
| .___|___| |
| | .___. | |
| |_. |_____|
| | |_______|
|___________|
`}, {
"coords": [[1,5], [3,2]],
"mazeData": `
.___________.
| | .___. . |
| | | ._| | |
| .___| ._| |
| | | ._|_. |
| | | | . |_|
|___|___|___|
`}];



/** WEBPACK FOOTER **
 ** ./lib/maze-data.js
 **/